import React from "react";
import Button from "material-ui/Button";
import { CardActions, CardContent } from "material-ui/Card";
import { TableBody, TableCell, TableRow } from "material-ui/Table";
import { withStyles } from "material-ui/styles";
import classnames from "classnames";

import CTable, { CHeadCell } from "uis/CTable";

const styles = () => ({
  container: {
    marginBottom: 10,
    minHeight: 315
  },
  title: {
    flex: 1
  },
  cardActionsRoot: {
    padding: 12
  },
  table: {},
  headCell: {
    textAlign: "left",
    padding: "0 10px",
    fontSize: ".9rem",
    width: 120
  },
  tableCell: {
    padding: "0 10px"
  },
  tableCellLeft: {
    padding: "0 10px",
    width: 400
  },
  tableRow: {
    height: 45
  },
  tableCellLogo: {
    padding: 10
  },
  clear: {
    clear: "both"
  }
});

const CustomerInfoCard = props => {
  const { classes, customer } = props;

  return (
    <div className={classes.container}>
      <CardActions classes={{ root: classes.cardActionsRoot }}>
        <h4 className={classes.title}>顧客基本情報</h4>

        <Button raised onClick={() => props.openCustomerModal(customer)}>
          編集
        </Button>
      </CardActions>

      <CardContent>
        <CTable className={classes.table}>
          <TableBody>
            <TableRow className={classes.tableRow}>
              <CHeadCell className={classes.headCell}>顧客名</CHeadCell>
              <TableCell className={classes.tableCellLeft}>
                {customer.customerName}
              </TableCell>

              <CHeadCell className={classes.headCell}>顧客ID</CHeadCell>
              <TableCell className={classes.tableCell}>
                {customer.customerKey}
              </TableCell>
            </TableRow>

            <TableRow className={classes.tableRow}>
              <CHeadCell className={classes.headCell}>産業分類</CHeadCell>
              <TableCell className={classes.tableCellLeft}>
                {`${customer.industryParent} - ${customer.industry}`}
              </TableCell>

              <CHeadCell className={classes.headCell}>従業員数</CHeadCell>
              <TableCell className={classes.tableCell}>
                {customer.employees} 名
              </TableCell>
            </TableRow>

            <TableRow className={classes.tableRow}>
              <CHeadCell className={classes.headCell}>使用可能言語</CHeadCell>
              <TableCell className={classes.tableCellLeft}>
                {customer.locales.map(l => l.jaLabel).join("、")}
              </TableCell>

              <CHeadCell className={classes.headCell}>企業規模</CHeadCell>
              <TableCell className={classes.tableCell}>
                {customer.employees >= 300 ? "大企業" : "中小企業"}
              </TableCell>
            </TableRow>

            <TableRow className={classes.tableRow}>
              <CHeadCell className={classes.headCell}>メモ</CHeadCell>
              <TableCell
                className={classnames(classes.tableCell, classes.tableCellLogo)}
                colSpan="3"
              >
                <div>{customer.memo}</div>
              </TableCell>
            </TableRow>
          </TableBody>
        </CTable>
      </CardContent>
    </div>
  );
};

export default withStyles(styles)(CustomerInfoCard);



// WEBPACK FOOTER //
// ./src/components/CustomerDetail/CustomerInfoCard.jsx